module.exports = __webpack_public_path__ + "assets/images/icons/icon_virus-orange.svg?v=a328e5c2";